import React from 'react'
import CollegeFootball from 'src/components/page/college-football'
import { teamIds } from 'src/constants/personalizationIds'
export default (props) => (
  <CollegeFootball
    {...props}
    team="Georgia Bulldogs"
    teamId={teamIds['Georgia Bulldogs']}
    poster="https://assets-imgx.fubo.tv/marketing/lp/images/posters/CFB/Georgia.png"
  />
)
